import React from 'react';
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import css from "../SidebarMenu.module.css";
import AddAlertIcon from '@material-ui/icons/AddAlert';
import DeleteIcon from '@material-ui/icons/Delete';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {deleteZone, setActiveZoneId} from "../../../store/notificationsSlice";
import {connect} from "react-redux";
import AlertList from "./AlertList/AlertList";
import {showAddingAlert} from "../../../store/modalsSlice";

const ZoneList = (props) => {
	const addAlert = zone => {
		props.showAddingAlert(zone);
	};

	const toggleFolderOpen = (zoneId) => {
		if( zoneId === props.activeZoneId )
			props.setActiveZoneId(null);
		else
			props.setActiveZoneId(zoneId);
	};

	const deleteZone = zone => {
		if( !window.confirm("Are you sure you want to delete this zone, and any alerts it contains?") )
			return;

		props.deleteZone(zone.zone_id);
	};

	const formatZone = zone => {
		const alerts = props.alerts.filter(a => a.zone_id === zone.zone_id);
		const open = props.activeZoneId === zone.zone_id;

		let alertsText = '';
		if( alerts.length > 0 )
			alertsText = ', ' + alerts.length + " alert" + (alerts.length === 1 ? "" : "s");


		// const squareKm = Math.round(3.1415 * zone.radius * zone.radius, 1);
		return (<React.Fragment key={'zone-' + zone.zone_id}>
				<ListItem button onClick={() => toggleFolderOpen(zone.zone_id)}>
					<ListItemIcon>
						<LocationOnIcon/>
					</ListItemIcon>
					<ListItemText primary={zone.name} secondary={/*squareKm + " sq km, " + */
						(zone.active_spawnpoints ? zone.active_spawnpoints.toLocaleString() : "Loading") + " spawnpoints" + alertsText
					} />
					{open ? <ExpandLess/> : <ExpandMore/>}
				</ListItem>
				<Collapse className={css.SidebarMenuCollapse} in={open} timeout="auto" unmountOnExit>
					<List component="div" disablePadding>
						{ zone.discord_id ? (
							<ListItem key={'del-zone-' + zone.zone_id} button className={css.SidebarItemNested} onClick={() => deleteZone(zone)}>
								<ListItemIcon>
									<DeleteIcon />
								</ListItemIcon>
								<ListItemText primary="Delete Zone" />
							</ListItem>
						) : null}

						<ListItem key={'add-alert-' + zone.zone_id} button className={css.SidebarItemNested} onClick={() => addAlert(zone)}>
							<ListItemIcon>
								<AddAlertIcon />
							</ListItemIcon>
							<ListItemText primary="Add Alert" />
						</ListItem>
						<AlertList alerts={alerts}/>
					</List>
				</Collapse>
			</React.Fragment>
		);
	};

	return (
		<>
			{props.zones.map(formatZone)}
		</>
	);
};


const mapStateToProps = (state) => {
	return {
		// NAME: state.NAME
		zones: state.notifications.zones,
		activeZoneId: state.notifications.activeZoneId,
		alerts: state.notifications.alerts
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setActiveZoneId: (zoneId) => dispatch(setActiveZoneId(zoneId)),
		showAddingAlert: (val) => dispatch(showAddingAlert(val)),
		deleteZone: (zoneId) => dispatch(deleteZone(zoneId))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ZoneList);